import pkg from "../../../package.json";
export default {
  state: {
    frontEndVersion: pkg.version,
    config: {
      buildId: process.env.VUE_APP_BUILD_ID || 'local-build'
    }
  },
  mutations: {
    frontEndVersion(state, value) {
      state.frontEndVersion = value;
    },
    config(state, value) {
      state.config = value;
    }
  },
  actions: {
    setFrontEndVersion({ commit }, value) {
      commit("frontEndVersion", value);
    },
    setConfig({ commit }, value) {
      commit("config", value);
    }
  },
  getters: {
    getFrontEndVersion: state => {
      return state.frontEndVersion;
    },
    getConfig: state => {
      return state.config;
    }
  }
};
